(function() {
    'use strict';
    angular
        .module('vobeApp')
        .factory('PublicSiteLanguage', PublicSiteLanguage);

    PublicSiteLanguage.$inject = ['$resource'];

    function PublicSiteLanguage ($resource) {
        var resourceUrl =  'api/public-site-languages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
